var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 14.6667V15.3333C2.66667 15.7013 2.96467 16 3.33333 16H5.33333C5.702 16 6 15.7013 6 15.3333V14.6667H2.66667Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.6667V15.3333C10 15.7013 10.298 16 10.6667 16H12.6667C13.0353 16 13.3333 15.7013 13.3333 15.3333V14.6667H10Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 5.33333H0V8.66667H1.33333V5.33333Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.33333H14.6667V8.66667H16V5.33333Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H4C2.89733 0 2 0.897333 2 2V13.3333C2 13.7013 2.29867 14 2.66667 14H13.3333C13.7013 14 14 13.7013 14 13.3333V2C14 0.897333 13.1027 0 12 0ZM4.66667 12C4.29867 12 4 11.7013 4 11.3333C4 10.9653 4.29867 10.6667 4.66667 10.6667C5.03467 10.6667 5.33333 10.9653 5.33333 11.3333C5.33333 11.7013 5.03467 12 4.66667 12ZM11.3333 12C10.9653 12 10.6667 11.7013 10.6667 11.3333C10.6667 10.9653 10.9653 10.6667 11.3333 10.6667C11.7013 10.6667 12 10.9653 12 11.3333C12 11.7013 11.7013 12 11.3333 12ZM12.6667 8.66667H3.33333V2.66667H12.6667V8.66667Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusFront);
export default __webpack_public_path__ + "static/media/bus-front.6d281faa.svg";
export { ForwardRef as ReactComponent };